import React from 'react'
import Head from 'next/head'

import ApplicationLayout from 'layouts/application'
import { Typography } from 'antd'
import { initializeApollo, addApolloState } from 'util/apolloClient'
import { Base_QueryDocument } from 'graphql/generated/types'

const title = `About Us`
const description = `About Us`

const AboutContent = () => (
  <>
    <Typography.Title level={2}>About Us</Typography.Title>
    <Typography.Title level={3}>
      “Personal Finance is no longer a want, but a need in the recent times.”
    </Typography.Title>
    <Typography.Text>
      If you feel finance is too complicated or have trouble decoding the
      complex jargon, worry no more. Fintrakk will provide all the important
      financial know-hows in a simple and easy-to-understand language.
    </Typography.Text>
    <Typography.Title level={3}>FINTRAKK</Typography.Title>
    <Typography.Text>
      We are an emerging financial education platform where you will not only
      learn about managing and growing your money but also engage in
      comprehensive and intuitive conversations with experts.
    </Typography.Text>
    <Typography.Text>
      We will help to kick start your financial journey and educate you from the
      beginning on:{' '}
      <ul>
        <li>Basic Financial Terms & Concepts</li>
        <li>In-depth & well-researched financial topics</li>
        <li>How to invest? Where to invest? When to invest?</li>
        <li>FAQs on finance, investment, stocks, cryptocurrency, etc.</li>
      </ul>
    </Typography.Text>
    <Typography.Text>
      Want to be a Finance Pro? Be a part of our two robust platforms:{' '}
      <a href="https://fintrakk.com">Fintrakk Blog</a> and{' '}
      <a href="https://app.fintrakk.com">Fintrakk Financial Hub</a>
    </Typography.Text>
    <p>
      <strong>
        “Personal Finance is no longer a want, but a need in the recent times.”
      </strong>
    </p>

    <p>
      If you feel finance is too complicated or have trouble decoding the
      complex jargon, worry no more.
      <strong>Fintrakk</strong> will provide all the important financial
      know-hows in a simple and easy-to- understand language.
    </p>

    <h2>
      <strong>FINTRAKK</strong>
    </h2>

    <p>
      We are an emerging <strong>financial education platform</strong> where you
      will not only learn about managing and growing your money but also engage
      in comprehensive and intuitive conversations with experts.&amp;nbsp;
    </p>

    <p>
      We will help to kick start your financial journey and educate you from the
      beginning on:
    </p>

    <ul>
      <li>Basic Financial Terms &amp;amp; Concepts</li>
      <li>In-depth &amp;amp; well-researched financial topics</li>
      <li>How to invest? Where to invest? When to invest?&amp;nbsp;</li>
      <li>FAQs on finance, investment, stocks, cryptocurrency, etc.</li>
    </ul>

    <p>Want to be a Finance Pro? Be a part of our two robust platforms:</p>
    <h3 className="has-text-align-center">
      <a href="https://fintrakk.com/" target="_blank" rel="noreferrer noopener">
        <strong>Fintrakk Blog</strong>
      </a>{' '}
      and{' '}
      <a
        href="https://app.fintrakk.com/"
        target="_blank"
        rel="noreferrer noopener"
      >
        <strong>Fintrakk Financial Hub</strong>
      </a>
    </h3>

    <p>
      So, what are you waiting for? Learn, interact and attain financial freedom
      and meet your ultimate goal of wealth creation.
    </p>

    <h3 className="has-text-align-center">
      <strong>
        <a
          href="https://app.fintrakk.com/auth/signin"
          target="_blank"
          rel="noreferrer noopener"
        >
          Create A Free Account: Ask Your Financial Query
        </a>
      </strong>
    </h3>
    <h2>
      <strong>What we have for you?</strong>
    </h2>
    <p>
      A vast library of financial knowledge to access, consume, and implement
      for free. All this to improve your investment journey!!
    </p>
    <p>We have incorporated an enormous section of topics related to:</p>

    <ul>
      <li>Investments</li>
      <li>Personal Finance</li>
      <li>Stock Markets</li>
      <li>Trading</li>
      <li>Taxation</li>
      <li>Career Options</li>
      <li>Cryptocurrencies</li>
      <li>Global Investment opportunities, etc.</li>
    </ul>
    <p>
      We are constantly adapting and evolving according to the current market
      dynamics and your needs. So, we created a unique FAQ section to get quick
      answers for all your financial queries on. So, don’t miss out to explore
      our:
    </p>
    <ul>
      <li>
        <a href="https://app.fintrakk.com/faqs/investment">Investment FAQs</a>
      </li>
      <li>
        <a href="https://app.fintrakk.com/faqs/finance">Finance FAQs</a>
      </li>
      <li>
        <a href="https://app.fintrakk.com/faqs/stock-market">
          Stock Market FAQs
        </a>
      </li>
      <li>
        <a href="https://app.fintrakk.com/faqs/ipo-basics">IPO Basics FAQs</a>
      </li>
      <li>
        <a href="https://app.fintrakk.com/faqs/option-trading">
          Option Trading FAQs
        </a>
      </li>
      <li>
        <a href="https://app.fintrakk.com/faqs/mutual-funds">
          Mutual Fund FAQs
        </a>
      </li>
      <li>
        <a href="https://app.fintrakk.com/faqs/cryptocurrency">
          Cryptocurrency FAQs
        </a>
      </li>
      <li>
        <a href="https://app.fintrakk.com/financial-terms">Financial Terms</a>
      </li>
    </ul>
    <p>
      <strong>
        And the best part!! You can consume all of these for free!!
      </strong>{' '}
      Engage in conversations with experts who are willing to resolve every
      financial query you have.
    </p>
    <p>
      Regardless of your background and profession, Fintrakk will assist you to
      understand Personal Finance and educate you on the necessary realms of the
      field.&amp;nbsp;
    </p>
    <p>
      Although we don’t provide any tips or trading recommendations, we provide
      the knowledge with which you can successfully select your tools for your
      wealth creation journey.
    </p>
    <p>
      It’s said that{' '}
      <strong>
        <em>
          ‘Give a man a fish and you will feed him for a day, but teach him how
          to fish and you feed him for a lifetime.’
        </em>
      </strong>
    </p>
    <p>
      Well at <strong>Fintrakk</strong> we say,{' '}
      <strong>
        <em>
          “Give a man a tip and he shall make money for a day, but teach them
          Personal Finance and they shall make money for the rest of their
          lives.”
        </em>
      </strong>
    </p>
    <h2>
      <strong>Who are we?</strong>
    </h2>
    <p>
      Ever been to a website and found yourself with questions but no one to ask
      them to?
    </p>
    <p>
      Well, we are here to provide answers to every small/big query. We have a
      team of finance professionals and community members who will cherish your
      engagement in discussions and debates.
    </p>
    <p>
      We always appreciate your smallest queries and your inputs on any of the
      topics. We are constantly evolving on your opinions and your valuable
      feedback means a lot to us. Our team looks forward to your queries and try
      to resolve them to the best of their abilities.
    </p>
    <h2>
      <strong>Founder: Harleen Kaur</strong>
    </h2>
    <p>
      A Chartered Accountant with 13+ years of experience in the Corporate
      world. A Finance &amp;amp; Crypto enthusiast, a passionate financial
      blogger. I love contributing towards the financial literacy goal through
      my business ventures and spreading awareness in the dynamic field of
      finance, investment, stock market, money savings, career, and a lot more.
      Reading, learning &amp;amp; sharing useful and interesting information,
      this is what I enjoy!!{' '}
      <em>
        <strong>
          In short, A CA, Blogger, Writer, Content Strategist, Contributor,
          Marketer, and an aspiring Entrepreneur!
        </strong>
      </em>
    </p>
    <p>
      <em>
        What are you waiting for? We are here to simplify finance for you!
      </em>
    </p>
    <h3 className="has-text-align-center">
      <strong>
        <a
          href="https://app.fintrakk.com/auth/signin"
          target="_blank"
          rel="noreferrer noopener"
        >
          Ask Your Financial Query Now
        </a>
      </strong>
    </h3>
    <p>Hope we make a positive difference in your financial journey!</p>
    <p>
      Follow us at{' '}
      <a href="https://twitter.com/fintrakk_blog">
        https://twitter.com/fintrakk_blog
      </a>{' '}
      and
      <a href="https://in.pinterest.com/fintrakk/">
        https://in.pinterest.com/fintrakk/
      </a>
    </p>
    <p>Go ahead and become a financially wise person.</p>
  </>
)

export default function AboutPage(props) {
  const { data: pageData } = props
  const {
    all_brokers: { data: allBrokers },
    nav_calculators: { data: navCalculators },
    all_pages: { data: allPages },
  } = pageData

  return (
    <ApplicationLayout
      allBrokers={allBrokers}
      navCalculators={navCalculators}
      allPages={allPages}
    >
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Head>
      <AboutContent />
    </ApplicationLayout>
  )
}

export async function getStaticProps() {
  const apolloClient = initializeApollo()

  const queryResults = await apolloClient.query({
    query: Base_QueryDocument,
  })
  const { data } = queryResults

  return addApolloState(apolloClient, { props: { data } })
}
